import React, { useState, useEffect } from "react";
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Typography, Select, MenuItem, Box } from "@mui/material";
import { getAvailableBallkidsForDay, getMealTicketStatus, updateMealTicketStatus } from "../firebaseService";
import { useTournamentConfig } from "../context/TournamentConfigContext";
import { useDefaultTournamentDay } from "../utils/useDefaultTournamentDay";

const MealTicketAllocation = () => {
  const { daysOfWeek } = useTournamentConfig();
  const [ballkids, setBallkids] = useState([]);
  const [mealTickets, setMealTickets] = useState({});
  const [selectedDay, setSelectedDay] = useDefaultTournamentDay(daysOfWeek);
  useEffect(() => {
    const fetchData = async () => {
      const availableBallkids = await getAvailableBallkidsForDay(selectedDay);
      const sortedData = availableBallkids.sort((a, b) => a.name.localeCompare(b.name));

      setBallkids(sortedData);
      const mealTicketData = await getMealTicketStatus(selectedDay);
      setMealTickets(mealTicketData);
    };
    fetchData();
  }, [selectedDay]);

  const handleToggle = async (ballkidId) => {
    const newStatus = !mealTickets[ballkidId];
    await updateMealTicketStatus(selectedDay, ballkidId, newStatus);
    setMealTickets((prev) => ({ ...prev, [ballkidId]: newStatus }));
  };

  return (
    <Box>
            <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
            Essensmarken
            </Typography>
      <Typography variant="subtitle1" sx={{ mt: 1 }}>
  Gesamtzahl benötigte Essensmarken: <strong>{ballkids.length}</strong>
</Typography>
      <Select value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}  sx={{
    color: 'white', // ausgewählter Text
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'white', // Randfarbe
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '.MuiSvgIcon-root': {
      color: 'white', // Icon-Farbe
    },
  }}>
        {daysOfWeek.map((day) => (
          <MenuItem key={day} value={day}>{day}</MenuItem>
        ))}
      </Select>
      
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Essensmarke erhalten</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ballkids.map((ballkid) => (
              <TableRow key={ballkid.id}>
                <TableCell>{ballkid.name || "Unbekannt"}</TableCell>
                <TableCell>
                  <Checkbox
                    checked={!!mealTickets[ballkid.id]}
                    onChange={() => handleToggle(ballkid.id)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MealTicketAllocation;